import RecruitmentApplyAddPage from 'pages/RecruitmentApply/RecruitmentApplyAddPage';
import RecruitmentApplyPage from 'pages/RecruitmentApply/RecruitmentApplyPage';

const recruitmentApplyRoute = [
  {
    path: '/recruitment-apply',
    exact: true,
    name: 'Danh sách hồ sơ tuyển dụng',
    function: 'CMS_RECRUITMENTAPPLY_VIEW',
    component: RecruitmentApplyPage,
  },
  {
    path: '/recruitment-apply/add',
    exact: true,
    name: 'Thêm mới hồ sơ tuyển dụng',
    function: 'CMS_RECRUITMENTAPPLY_ADD',
    component: RecruitmentApplyAddPage,
  },
  {
    path: '/recruitment-apply/edit/:recruitment_apply_id',
    exact: true,
    name: 'Chỉnh sửa hồ sơ tuyển dụng',
    function: 'CMS_RECRUITMENTAPPLY_EDIT',
    component: RecruitmentApplyAddPage,
  },
  {
    path: '/recruitment-apply/detail/:recruitment_apply_id',
    exact: true,
    name: 'Chi tiết hồ sơ tuyển dụng',
    function: 'CMS_RECRUITMENTAPPLY_VIEW',
    component: RecruitmentApplyAddPage,
  },
];

export default recruitmentApplyRoute;
